import type { ReactNode } from "react";

/**
 * Einheitliche Karte für Abschnitte im internen Bereich.
 * Farben ausschließlich über semantische Tokens.
 */
export function AdminCard({
  title,
  description,
  actions,
  children,
  className,
}: {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  return (
    <section
      className={
        "rounded-lg border border-border bg-background p-6 " + (className ?? "")
      }
    >
      {title || actions ? (
        <div className="grid grid-cols-[minmax(0,1fr)_auto] items-start gap-3 sm:flex sm:flex-wrap sm:justify-between">
          <div className="min-w-0">
            {title ? (
              <h2 className="font-display text-lg font-extrabold text-brand-petrol">{title}</h2>
            ) : null}
            {description ? (
              <p className="mt-1 text-xs text-muted-foreground">{description}</p>
            ) : null}
          </div>
          {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      {children ? <div className={title || actions ? "mt-4" : ""}>{children}</div> : null}
    </section>
  );
}
